import { render, staticRenderFns } from "./RequestNewEmployee.vue?vue&type=template&id=5045aaf6&"
import script from "./RequestNewEmployee.vue?vue&type=script&lang=js&"
export * from "./RequestNewEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports